'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.months;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/months.js
// module id = 197
// module chunks = 0